<div class="main-container waste-input-container">
    <form #dataForm="ngForm" class="waste-input-form fh">
        <div class="form-field-container">
            <div class="row-split">
                <div class="who-container">
                    <mat-form-field appearance="outline" class="left-texbox">
                        <mat-label>{{'5w1h.who' | translate}}</mat-label>
                        <textarea disabled matInput name="who" #who maxlength="256" matTextareaAutosize="true"
                            matAutosizeMinRows="1" matAutosizeMaxRows="15" [(ngModel)]="comment.Who"
                            [pattern]="validationPattern" #whoValidation="ngModel"
                            (focus)="this.addTransformerWho = true;" (blur)="this.addTransformerWho = false"
                            (input)="valueChanged(who.value.length)"></textarea>
                        <mat-hint align="start" *ngIf="whoValidation.errors?.pattern" class="who-error">
                            {{'5w1h.errors.special_char' | translate}}
                        </mat-hint>
                    </mat-form-field>
                </div>

                <div class="what-container">
                    <mat-form-field appearance="outline" class="right-texbox">
                        <mat-label>{{'5w1h.what' | translate}}</mat-label>
                        <textarea matInput name="what" #what maxlength="256" matTextareaAutosize="true"
                            matAutosizeMinRows="1" matAutosizeMaxRows="15" [(ngModel)]="comment.What"
                            [pattern]="validationPattern" #whatValidation="ngModel"
                            (focus)="this.addTransformerWhat = true" (blur)="this.addTransformerWhat = false"
                            (input)="valueChanged(what.value.length)"></textarea>
                        <mat-hint align="start" *ngIf="whatValidation.errors?.pattern" class="what-error">
                            {{'5w1h.errors.special_char' | translate}}
                        </mat-hint>
                    </mat-form-field>
                    <div class="what-string-length"
                        [ngClass]="what.value.length > 0 || this.addTransformerWhat ? 'transformer-class' : ''">
                        {{what.value.length}} / 256
                    </div>
                </div>
            </div>

            <div class="row-split">
                <div class="fromDate-container">

                    <mat-form-field appearance="outline" class="left-texbox">
                        <mat-label>{{'5w1h.when' | translate}} ({{'5w1h.whenFromDate' | translate}})</mat-label>

                        <input matInput name="fromDateDisplay" [(ngModel)]="fromDateTimeDisplay" [disabled]='true'
                            class="fromDateDisplay">

                        <input matInput [max]="max" [owlDateTime]="dtFrom" name="fromDate" [(ngModel)]="fromDateTime"
                            (dateTimeInput)="valueChanged(fromDateTime, 'fromDateChanged')" #fromDate="ngModel"
                            class="fromDate">
                        <owl-date-time #dtFrom></owl-date-time>
                    </mat-form-field>
                    <mat-icon aria-hidden="false" aria-label="From Calendar" class="calendar from_calendar"
                        [owlDateTimeTrigger]="dtFrom" (click)="setMaxDate()" (keydown)="setMaxDate()">
                        calendar_today
                    </mat-icon>
                </div>

                <div class="toDate-container">
                    <mat-form-field appearance="outline" class="left-texbox">
                        <mat-label>{{'5w1h.when' | translate}} ({{'5w1h.whenToDate' | translate}})</mat-label>

                        <input matInput name="toDateDisplay" [(ngModel)]="toDateTimeDisplay" [disabled]='true'
                            class="toDateDisplay">

                        <input matInput [min]="min" [max]="max" [owlDateTime]="dtTo" name="toDate"
                            [(ngModel)]="toDateTime" (dateTimeInput)="valueChanged(toDateTime, 'toDateChanged')"
                            #toDate="ngModel" [disabled]='!showToDate' class="toDate">
                        <owl-date-time #dtTo></owl-date-time>
                    </mat-form-field>
                    <mat-icon aria-hidden="false" aria-label="To Calendar" class="calendar to_calendar"
                        [owlDateTimeTrigger]="dtTo" (click)="setMaxDate()" (keydown)="setMaxDate()">
                        calendar_today
                    </mat-icon>
                </div>
                <div class="where-container">
                    <mat-form-field appearance="outline" class="right-texbox">
                        <mat-label>{{'5w1h.where' | translate}}</mat-label>
                        <textarea matInput name="where" #where maxlength="256" matTextareaAutosize="true"
                            matAutosizeMinRows="1" matAutosizeMaxRows="15" [(ngModel)]="comment.Where"
                            [pattern]="validationPattern" #whereValidation="ngModel"
                            (focus)="this.addTransformerWhere = true" (blur)="this.addTransformerWhere = false"
                            (input)="valueChanged(where.value.length)"></textarea>
                        <mat-hint align="start" *ngIf="whereValidation.errors?.pattern" class="where-error">
                            {{'5w1h.errors.special_char' | translate}}
                        </mat-hint>
                    </mat-form-field>
                    <div class="where-string-length"
                        [ngClass]="where.value.length > 0 || this.addTransformerWhere ? 'transformer-class' : ''">
                        {{where.value.length}} / 256
                    </div>
                </div>
            </div>

            <div class="row-split">
                <div class="why-container">
                    <mat-form-field appearance="outline" class="left-texbox">
                        <mat-label>{{'5w1h.why' | translate}}</mat-label>
                        <textarea matInput name="why" #why maxlength="256" matTextareaAutosize="true"
                            matAutosizeMinRows="1" matAutosizeMaxRows="15" [(ngModel)]="comment.Why"
                            [pattern]="validationPattern" #whyValidation="ngModel"
                            (focus)="this.addTransformerWhy = true" (blur)="this.addTransformerWhy = false"
                            (input)="valueChanged(why.value.length)"></textarea>
                        <mat-hint align="start" *ngIf="whyValidation.errors?.pattern" class="why-error">
                            {{'5w1h.errors.special_char' | translate}}
                        </mat-hint>
                    </mat-form-field>
                    <div class="why-string-length"
                        [ngClass]="why.value.length > 0 || this.addTransformerWhy ? 'transformer-class' : ''">
                        {{why.value.length}} / 256
                    </div>
                </div>

                <div class="how-container">
                    <mat-form-field appearance="outline" class="right-texbox">
                        <mat-label>{{'5w1h.how' | translate}}</mat-label>
                        <textarea matInput name="how" #how maxlength="256" matTextareaAutosize="true"
                            matAutosizeMinRows="1" matAutosizeMaxRows="15" [(ngModel)]="comment.How"
                            [pattern]="validationPattern" #howValidation="ngModel"
                            (focus)="this.addTransformerHow = true" (blur)="this.addTransformerHow = false"
                            (input)="valueChanged(how.value.length)"></textarea>
                        <mat-hint align="start" *ngIf="howValidation.errors?.pattern" class="how-error">
                            {{'5w1h.errors.special_char' | translate}}
                        </mat-hint>
                    </mat-form-field>
                    <div class="how-string-length"
                        [ngClass]="how.value.length > 0 || this.addTransformerHow ? 'transformer-class' : ''">
                        {{how.value.length}} / 256
                    </div>
                </div>
            </div>
        </div>

        <div class="form-button-container">
            <button mat-flat-button color="primary" class="submit" (click)="validate_form(dataForm)" type="button"
                [disabled]="!(this.changedValue && dataForm?.valid)">
                <ng-container>{{'common.submit' | translate}}</ng-container>
            </button>
        </div>
    </form>
</div>

<p #commentAdded [hidden]="true">{{"5w1h.comments_added" | translate}}</p>
<p #commentUpdated [hidden]="true">{{"5w1h.comments_updated" | translate}}</p>